export default [
  {
    path: '/role',
    name: 'rolePage',
    component: () => import(/*webpackChunkName:'role'*/ '@/views/role/RolePage.vue'),
    meta: {},
  },
];
